<div id="wrapper">
    <app-loading-screen [status]="false"></app-loading-screen>
    <div>
        <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
    </div>
    <div style="margin-bottom:0px;">
        <app-tab-nav (updatePostpaid)="this.postpago=$event" (updatePrepaid)="this.prepago=$event" (updateFixed)="this.telefoniaFijo=$event" (updateTotalAccountList)="this.totalAccountList=$event" (updateCurrentList)="this.currentList=$event" (updateSelectBan)="this.selectBan=$event"
            (updateInitializeData)="this.initializeData()"></app-tab-nav>
    </div>
    <div class="allcont logsize">
        <div class="basicrow" [hidden]="this.prepago==false">
            <div class="container">
                <div class="basicr-line-i" style="padding-top: 20px;">
                    <div class="fulltitle  f-btitle autodef" >
                        <span class="icon-dash-29"></span> Transacciones
                    </div>
                </div>
            </div>
        </div>
        <div class="basicrow mbott m-top-i" [hidden]="this.prepago==false">
            <div class="container">
                <div class="autowcont notopbrd " *ngFor="let subscriber of this.subscribers; let i = index">
                    <div data-toggle="collapse" [attr.data-target]="'#tabC_'+i" class="digs-box-f vcenter mob-txt" (click)="updateExpand(i)" [ngClass]="{'mon': this.expand[i] == true,'': this.expand[i] == false}">
                        <div class="tabcell">
                            <div class="autorow pull-left">
                                <span class="roboto-l">M&Oacute;VIL</span>
                                <span class="roboto-m">{{this.global.mask(subscriber.subscriberNumberField)}}</span>
                            </div>

                            <div class="autorow pull-right">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                                <i class="fa fa-minus" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                    <div id="tabC_{{i}}" class="collapse" [ngClass]="{'show': i == 0,'': i > 0}">
                        <div class="basicrow tabtopb f-black roboto-r f-reg">
                            <div class="basicr f-big">
                                Hist&oacute;rico de Transacciones
                            </div>

                            <div class="basicrow text-center">
                                <div class="shortcont">
                                    <div class="basicrow" style="display: none;">
                                        <div class="basicrow f-bmed roboto-b">
                                            Seleccione el Per&iacute;odo:
                                        </div>

                                        <div class="basicrow">
                                            <div class="row">
                                                <div class="col-xs-12 col-sm-12 col-lg-6 m-top-i w-t">
                                                    <div class="basicrow f-med roboto-b m-bott-ii">
                                                        Mes
                                                    </div>
                                                    <select class="sel-f" [(ngModel)]="this.month">
                                                        <option disabled selected>Seleccione un més</option>
                                                        <option value="0">Enero</option>
                                                        <option value="1">Febrero</option>
                                                        <option value="2">Marzo</option>
                                                        <option value="3">Abríl</option>
                                                        <option value="4">Mayo</option>
                                                        <option value="5">Junio</option>
                                                        <option value="6">Julio</option>
                                                        <option value="7">Agosto</option>
                                                        <option value="8">Septiembre</option>
                                                        <option value="9">Octubre</option>
                                                        <option value="10">Noviembre</option>
                                                        <option value="11">Diciembre</option>
                                                    </select>
                                                </div>

                                                <div class="col-xs-12 col-sm-12 col-lg-6 m-top-i w-t">
                                                    <div class="basicrow f-med roboto-b m-bott-ii">
                                                        A&ntilde;o
                                                    </div>

                                                    <select class="sel-f" [(ngModel)]="this.year">
                                                        <option disabled selected>Seleccione un año</option>
                                                        <option *ngFor="let year of this.yearArray; let i = index ">
                                                            {{year}}</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-xs-12 col-sm-12 col-lg-6 m-top-i w-t">
                                                    <select class="sel-f" [(ngModel)]="this.type">
                                                        <option disabled selected>Seleccione Tipo</option>
                                                        <option value="Transacciones">Transacciones</option>
                                                        <!--
                                                        <option value="Recarga de Prepago">Recarga de Prepago</option>
                                                        <option value="Transferencia de Dinero">Transferencia de Dinero
                                                        </option>
                                                        <option value="Cambio de Plan">Cambio de Plan</option>
                                                        -->
                                                    </select>
                                                </div>
                                                <!--
                                                <div class="col-xs-12 col-sm-12 col-lg-6 m-top-i w-t">
                                                    <select class="sel-f" [(ngModel)]="this.status">
                                                        <option disabled selected>Seleccione Estatus</option>
                                                        <option value="Estatus">Estatus</option>
                                                        <option value="Aprobada">Aprobada</option>
                                                        <option value="Rechazada">Rechazada</option>
                                                        <option value="Error">Error</option>

                                                    </select>
                                                </div>
                                            -->
                                            </div>
                                        </div>

                                        <div class="basicrow m-top-i">
                                            <a class="btns red def-i pull-right vcenter pull-right-t" (click)="this.refillOffersBySub(i);">
                                                <span class="tabcell">
                                                    Buscar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                                                </span>
                                            </a>

                                            <a href="/home" class="btns gray def-i pull-left vcenter b-m-t">
                                                <span class="tabcell">
                                                    Cancelar
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="basicrow m-top-i">
                                        <div class="logline full"></div>
                                    </div>
                                    <div class="basicrow m-top-ii">
                                        <div class="basicrow f-bmed roboto-b basicr-line">
                                            Recargas Recientes
                                        </div>
                                        <div class="basicrow hidden-xs m-top" *ngIf="this.offers==0">
                                            <div class="cellscont f-reg f-black p-box">
                                                Estimado cliente no existen registros de acuerdo a su busqueda
                                            </div>
                                        </div>
                                        <div *ngIf='this.offers.offers'>
                                            <div *ngFor="let trans of this.offers.offers[i].offers[0].offersData; let i = index" class="basicrow m-top">
                                                <div class="userinfo full nomtops">
                                                    <div class="basicrow f-black roboto-b f-bmed">
                                                        Transacci&oacute;n: {{trans.offers[0].transactionId}}
                                                    </div>
                                                    <div class="redstat m-top-ii">
                                                        <div class="autorow roboto-r pull-left">
                                                            Estatus
                                                        </div>
                                                        <div class="autorow roboto-b pull-right">
                                                            Aprobada
                                                        </div>
                                                    </div>

                                                    <div class="redstat m-top-ii">
                                                        <div class="autorow roboto-r pull-left">
                                                            Fecha
                                                        </div>
                                                        <div class="autorow roboto-b pull-right">
                                                            {{trans.offers[0].date | date :'medium'}}
                                                        </div>
                                                    </div>

                                                    <div class="redstat m-top-ii">
                                                        <div class="autorow roboto-r pull-left">
                                                            Monto
                                                        </div>
                                                        <div class="autorow roboto-b f-red pull-right">
                                                            {{trans.offers[0].amount}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>